import { PrismicRichText } from "@prismicio/react";
import { Button, Icon } from "@/components";
import { useState, useRef, useEffect } from "react";

import Styles from "./ProductDetails.module.css";

/**
 * @typedef {import("@prismicio/client").Content.ProductDetailsSlice} ProductDetailsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProductDetailsSlice>} ProductDetailsProps
 * @param {ProductDetailsProps}
 */
const ProductDetails = ({ slice: { primary, items } }) => {
	const [activeTab, setActiveTab] = useState(0);
	const panelContainer = useRef();

	const setPanelHeight = (panel) => {
		const height = panel?.scrollHeight;
		if (!height) return;
		panelContainer.current.style.minHeight = `${height + 60}px`;
	};

	const handleClick = (event, index) => {
		const activePanel =
			event.target.parentElement.parentElement.nextElementSibling.children[
				index
			];
		setPanelHeight(activePanel);
		setActiveTab(index);
	};

	useEffect(() => {
		const defaultPanel = panelContainer?.current?.children[0];
		setPanelHeight(defaultPanel);
	}, [panelContainer]);

	// Check if no items exist
	if (items.length === 0) {
		return null;
	}

	return (
		<section className={Styles.wrapper}>
			<div className={Styles.container} data-contain="true">
				<div className={Styles.col}>
					<div className={Styles.tabsContainer}>
						<div className={Styles.btnWrapper}>
							<div className={Styles.btnContainer}>
								<div className={Styles.arrowContainer}>
									<Icon icon="ChevronRight" className={Styles.arrow} size={30} />
								</div>
								{items.map((item, index) => (
									<button
										className={Styles.tabBtn}
										onClick={(event) => handleClick(event, index)}
										data-active={activeTab === index}
										key={index}
									>
										{item?.tab_title}
									</button>
								))}
							</div>
						</div>
						<div className={Styles.contentContainer} ref={panelContainer}>
							{items.map((item, index) => (
								<div
									className={Styles.tabContent}
									data-active={activeTab === index}
									key={index}
								>
									<PrismicRichText field={item?.tab_content} />
								</div>
							))}
						</div>
					</div>
				</div>
				{/* <div className={Styles.col}>
					<h2>{primary?.heading}</h2>
					<PrismicRichText field={primary?.description} />
					<Button link={primary?.cta_link} label={primary?.cta_label} />
				</div> */}
			</div>
		</section>
	);
};

export default ProductDetails;
